import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class SliderTestimaonials {
  constructor(el) {
    this.el = el
    this.titleEl = el.querySelector('.testimonials--title')
    this.init()
  }

  updateTitle(swiper) {
    const slide = swiper.slides[swiper.activeIndex]
    if (slide && this.titleEl) {
      this.titleEl.textContent = slide.dataset.title || ''
    }
  }

  init() {
    const swiper = new Swiper(this.el.querySelector('.testimonials--swiper'), {
      modules: [Navigation, Autoplay],
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      slidesPerView: 1,
      speed: 600,
      loop: true,
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
        prevEl: this.el.querySelector('.swiper-button-prev'),
      },
    })

    swiper.on('init', () => this.updateTitle(swiper))
    swiper.on('slideChange', () => this.updateTitle(swiper))
    swiper.emit('init')
  }
}
